module.exports = __webpack_public_path__ + "img/bhang_product-3.48610edd.jpg";